const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-u-size-inline">
  `);
                context.set('_parent', context.clone());

                (() => {
                    let c = this.ensureTraversable(this.createRange(2, 6));

                    if (c === context) {
                        context.set('_seq', context.clone());
                    }
                    else {
                        context.set('_seq', c);
                    }
                })();

                this.iterate(context.get('_seq'), (__key__, __value__) => {
                    context.proxy[`_key`] = __key__;
                    context.proxy[`columns`] = __value__;
                    this.echo(`    <div>
      <div class="u-size-inline-1/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(4, this.source)(...[this.env, context.get(`columns`), `html`, null, true]));
                    this.echo(` u-pad-n1 u-rounded t-dark t-alternate u-text-center">
        1/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(5, this.source)(...[this.env, context.get(`columns`), `html`, null, true]));
                    this.echo(`
      </div>
      <div class="u-size-inline-`);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, (context.get(`columns`) - 1), `html`, null, true]));
                    this.echo(`/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(7, this.source)(...[this.env, context.get(`columns`), `html`, null, true]));
                    this.echo(` u-pad-n1 u-rounded t-dark t-alternate u-text-center">
        `);
                    this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, (context.get(`columns`) - 1), `html`, null, true]));
                    this.echo(`/`);
                    this.echo(this.env.getFilter('escape').traceableCallable(8, this.source)(...[this.env, context.get(`columns`), `html`, null, true]));
                    this.echo(`
      </div>
    </div>
  `);
                });
                (() => {
                    let parent = context.get('_parent');
                    context.delete('_seq');
                    context.delete('_iterated');
                    context.delete('_key');
                    context.delete('columns');
                    context.delete('_parent');
                    context.delete('loop');
                    for (let [k, v] of parent) {
                        if (!context.has(k)) {
                            context.set(k, v);
                        }
                    }
                })();
                this.echo(`  <div>
    <div class="u-size-inline-full u-pad-n1 u-rounded t-dark t-alternate u-text-center">
      full
    </div>
  </div>
  <div>
    <div class="u-size-inline-auto u-pad-n1 u-rounded t-dark t-alternate u-text-center">
      auto
    </div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `78b176d9997a14e5f4db8c23838adf37379a4eb218a0b3e9de423985f19bed53`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `78b176d9997a14e5f4db8c23838adf37379a4eb218a0b3e9de423985f19bed53`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, '78b176d9997a14e5f4db8c23838adf37379a4eb218a0b3e9de423985f19bed53');

let template = env.loadTemplate('78b176d9997a14e5f4db8c23838adf37379a4eb218a0b3e9de423985f19bed53');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/size/demo/inline-size.twig", args: context }
     );
     return rendered;;
};